import { cleavageUndefined } from '../../../messages/infra';
export class InMemoryCurrentCleavageRepository {
    hasCleavage() {
        return Promise.resolve(!!this.cleavage);
    }
    load() {
        return this.cleavage
            ? Promise.resolve(this.cleavage)
            : Promise.reject(new Error(cleavageUndefined));
    }
    save(cleavage) {
        this.cleavage = cleavage;
        return Promise.resolve();
    }
}
